export interface BillingPresentation {
  workspace_messages: { id: string; tone: string; text: string }[]
  billing_messages: { id: string; tone: string; text: string }[]
  actions: { id: string; label: string }[]
  access: { read_only: boolean; migration_protected: boolean; status: string }
  next_actor: string
  state: string
  freshness: { source: string; projected_at: string | null; uncertain: boolean }
  billing_page_available: boolean
}

// The preview intentionally uses the same renderer without click handlers.
export function BillingPresentationNotices({ presentation }: { presentation?: BillingPresentation | null }) {
  if (!presentation || presentation.state === 'unavailable') return null
  return <div className="space-y-3" data-testid="persistent-billing-messages">
    {presentation.billing_messages.map(message => <div key={message.id} className={`rounded-xl border p-4 text-sm text-text-primary ${message.tone === 'warning' ? 'border-amber-200 bg-amber-50' : 'border-stone/30 bg-white'}`}>{message.text}</div>)}
    <p className="text-xs text-text-muted">Next responsible actor: {presentation.next_actor}. {presentation.freshness.source}. {presentation.freshness.projected_at ? `Last provider event: ${presentation.freshness.projected_at}.` : 'No provider event timestamp available.'} {presentation.freshness.uncertain && 'Confirmation may still be pending.'}</p>
  </div>
}

export function billingAction(presentation: BillingPresentation | null | undefined, id: string) {
  return presentation?.actions.some(action => action.id === id) === true
}